import React from 'react'

const Campus = ({handleChange,values,campus,handleErreur}) => {
    
    const getCampus = ()=>{
        return campus?.map((camp) => {
            return <option key={camp.id}  value={camp.id}>{camp.libelle} 
                </option>;
            });
    }
    if (values.idModaliteSuivi =="121581"/*Présentiel*/)
    {
        return (
            <div class="d-flex flex-column mt-sm-0 mt-4">
                <label className="mb-2">Quel campus vous intéresse en priorité ?*</label>
                <select 
                    type="text" 
                    value={values.idCampus}
                    onChange={handleChange("idCampus")}
                    id="idCampus"
                >
                <option value="0" selected="selected"></option>
                {getCampus()}
                </select>  
                {handleErreur("idCampus")}                
            </div>
        )
    }else{
        return <></>
    }
}

export default Campus